import React, { Fragment, useState, useEffect, useContext, useRef } from 'react';
import { Prompt } from 'react-router';
import { LangContext } from '../../context/lang-context'
import useFetch from '../../hooks/fetchMSSQL-hook';
import { NotificationContext } from '../../context/notification-context';

import TextInput from '../FormElements/TextInput';
import DatalistInput from '../FormElements/DatalistInput';
import { NotificationManager } from 'react-notifications';
import { LoaderContext } from '../../context/loader-context';
import ImportExtendedModal from '../Modals/ImportExtendedModal';
import ImportWarningModal from '../Modals/ImportWarningModal';
let tableRowId = 0;

const MachineProducts = (props) => {
  const { fetchMssqlApi } = useFetch();
  const machineProductsInputRef = useRef(null)
  const importTargetMachinesRef = useRef([])
  const initialRequestsSentRef = useRef(false)
  const [isMachineProductsImporting, setIsMachineProductsImporting] = useState(false)
  const [isMachineProductsExporting, setIsMachineProductsExporting] = useState(false)
  const [showImportExtendedModal, setShowImportExtendedModal] = useState(false)
  const [showImportWarningModal, setShowImportWarningModal] = useState(false)
  const [isImportMachinesLoading, setIsImportMachinesLoading] = useState(false)
  const [importMachines, setImportMachines] = useState([])
  const [selectedImportMachines, setSelectedImportMachines] = useState([])
  const [currentImportMachine, setCurrentImportMachine] = useState(null)
  const [pendingImportFile, setPendingImportFile] = useState(null)
  const [pendingImportMachines, setPendingImportMachines] = useState([])
  const { ErrorNotification } = useContext(NotificationContext);
  const { loader } = useContext(LoaderContext)

  const { TRL_Pack } = useContext(LangContext)

  const [machineProducts, setMachineProducts] = useState([]);
  const [initialMachineProducts, setInitialMachineProducts] = useState([]);
  const [isTableModified, setIsTableModified] = useState(false);
  const [product, setProduct] = useState([])
  const [productLookupType, setProductLookupType] = useState('name')
  const [nrSet,SetNrSet] = useState([])
  const [mdbSet,SetMDBSet] = useState([])
  const [isLoading, setIsLoading] = useState(loader)
  useEffect(() => {
    if (initialRequestsSentRef.current) return;

    initialRequestsSentRef.current = true;

    getMachineProducts();
    fetchMssqlApi('products', { method: "POST", hideNotification: true, data: {}}, response => setProduct(response));
  }, [])
  useEffect(() => {
    SetNrSet(Array.from(machineProducts.map(product => product.MachineFeederNo)))
  }, [machineProducts])
  useEffect(() => {
    SetMDBSet(Array.from(machineProducts.map(product => product.TrxProductNo && product.TrxProductNo)))
  }, [machineProducts])
  useEffect(() => {
    setIsTableModified(false);
    machineProducts.some(machineProduct => {
      if (machineProduct.RequestMethod) {
        setIsTableModified(true);
        return true;
      }
    });
  }, [machineProducts])


  const getMachineProducts = () => {
    const params = {
      machineId: props.machineId
    };

    fetchMssqlApi(`machine-products`, { method: 'GET', data: null, hideNotification: false, params }, machineProducts => {
      const newMachineProducts = machineProducts.map(machineProduct => ({
        ...machineProduct,
        DiscountedPrice: machineProduct.DiscountedPrice !== null ? machineProduct.DiscountedPrice : '',
        RequestMethod: null }));
      setInitialMachineProducts(newMachineProducts);
      setMachineProducts(newMachineProducts);
    });
  }

const handleChange = (machineProductId, e, tableRow) => {
  const name = e.target.name;
  let selectedProduct = null;

  let value =
    name === 'PriceBrutto' ? parseFloat(e.target.value) : e.target.value;

  if (name === 'Name') {
    selectedProduct = findProductByLookupValue(value);
    value = selectedProduct ? selectedProduct.Name : value;
  }
    let index = machineProducts.findIndex(machineProduct => machineProduct.MachineProductId === machineProductId);

    if (tableRow !== undefined) index = machineProducts.findIndex(machineProduct => machineProduct.TableRowId === tableRow);

    const initialMachineProductIndex = initialMachineProducts.findIndex(initialMachineProduct => initialMachineProduct.MachineProductId === machineProductId);
    let newMachineProducts = [...machineProducts];
    let requestMethod = !newMachineProducts[index].RequestMethod || newMachineProducts[index].RequestMethod === 'DELETE' ? 'PUT' : newMachineProducts[index].RequestMethod;
    newMachineProducts[index] = {
      ...newMachineProducts[index],
      [name]: value,
      ...(name === 'Name' ? { SelectedEAN: selectedProduct?.EAN || null } : {})
    };


    if (equalMachineProduct(initialMachineProducts[initialMachineProductIndex], newMachineProducts[index])) {
      requestMethod = null;
    }

    newMachineProducts[index] = { ...newMachineProducts[index], RequestMethod: requestMethod };

    setMachineProducts(newMachineProducts);
  }

  const toggleDeleteMachineProduct = machineProductId => {
    const index = machineProducts.findIndex(machineProduct => machineProduct.MachineProductId === machineProductId);
    const initialMachineProductIndex = initialMachineProducts.findIndex(initialMachineProduct => initialMachineProduct.MachineProductId === machineProductId);

    let newMachineProducts = [...machineProducts];

    let requestMethod = 'DELETE';

    if (newMachineProducts[index].RequestMethod === 'DELETE') {
      requestMethod = null;

      if (!equalMachineProduct(initialMachineProducts[initialMachineProductIndex], newMachineProducts[index]))
        requestMethod = 'PUT';
    }

    newMachineProducts[index] = { ...newMachineProducts[index], RequestMethod: requestMethod };

    setMachineProducts(newMachineProducts);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    let productId;

    const modifiedMachineProducts = machineProducts.filter(machineProduct => machineProduct.RequestMethod !== null);
    modifiedMachineProducts.forEach((machineProduct, i) => {

          let _getMachineProducts = false;

          if (i === modifiedMachineProducts.length - 1) {
            _getMachineProducts = true;
          }
          const { DiscountedPrice, MachineProductId, MachineInventoryItemId, MachineFeederNo, Name, PriceBrutto, Quantity, MaxItemCount, TrxProductNo, RequestMethod } = machineProduct;
          if (RequestMethod) {
            let initialProduct;
            if (machineProduct.TableRowId) {
              initialProduct = initialMachineProducts.find(p => p.TableRowId === machineProduct.TableRowId);
            } else if (MachineInventoryItemId) {
              initialProduct = initialMachineProducts.find(p => p.MachineInventoryItemId === MachineInventoryItemId && p.MachineProductId === MachineProductId);
            } else {
              initialProduct = initialMachineProducts.find(p => p.MachineProductId === MachineProductId);
            }
            
            if (initialProduct && Number(initialProduct.Quantity) !== Number(Quantity)) {
              fetchMssqlApi(`add-machine-log`, {
                  method: 'POST',
                  data: {
                      MachineId: props.machineId,
                      MachineProductId,
                      MachineFeederNo,
                      BeforeValue: initialProduct.Quantity,
                      AfterValue: Quantity,
                      Source: 'PORTAL',
                      Type: 'E'
                  },
                  hideNotification: true
              }, () => {})
            }
            productId = getProductId(Name, machineProduct);
            let isEqual
            for (let x = 0; x < modifiedMachineProducts.length - 1; x++) {
              if (modifiedMachineProducts[x].MachineFeederNo === modifiedMachineProducts[x + 1].MachineFeederNo) {
                isEqual = true

              }
            }
            if (isEqual === true) {
              return NotificationManager.error(TRL_Pack.errors.sameNumber);
            }


            if (MachineFeederNo && Name && PriceBrutto !== '' && PriceBrutto !== null && PriceBrutto !== undefined && !Number.isNaN(Number(PriceBrutto)) && Number(PriceBrutto) >= 0 && Quantity !== '' && Quantity !== null && Quantity !== undefined && parseInt(Quantity) >= 0 && MaxItemCount && parseInt(MaxItemCount) >= 0 && parseInt(MaxItemCount) >= parseInt(Quantity)) {
              const data = {
                MachineId: props.machineId,
                MachineFeederNo: MachineFeederNo,
                MachineProductId: parseInt(MachineProductId),
                Ean: parseInt(productId),
                Price: parseFloat(PriceBrutto),
                DiscountedPrice: parseFloat(DiscountedPrice),
                Quantity: parseInt(Quantity),
                MaxItemCount: parseInt(MaxItemCount),
                TrxProductNo: parseInt(TrxProductNo)
              }
              if (RequestMethod !== "DELETE" && nrSet
                  .filter(machienFeederNo => MachineFeederNo === machienFeederNo).length > 1) {
                setMachineProducts(products => products.map(item =>
                    (
                        item.TableRowId && item.TableRowId === machineProduct.TableRowId ||
                        item.MachineInventoryItemId && item.MachineInventoryItemId === machineProduct.MachineInventoryItemId
                    )
                        ? ({...item, MachineFeederNo: ""})
                        : item
                ))
                NotificationManager.error("Taki numer wyboru już istnieje");
                return
              }
              if (RequestMethod !== "DELETE" && TrxProductNo && mdbSet
                  .filter(mdb =>  mdb === TrxProductNo).length > 1) {
                setMachineProducts(products => products.map(item =>
                    (
                        item.TableRowId && item.TableRowId === machineProduct.TableRowId
                        ||
                        item.MachineInventoryItemId && item.MachineInventoryItemId === machineProduct.MachineInventoryItemId
                    )
                        ? ({...item, TrxProductNo: ""})
                        : item
                ))
                NotificationManager.error("Taki numer MDB już istnieje");
                return
              }
              if (RequestMethod === 'POST') {
                fetchMssqlApi(`machine-product`, { method: RequestMethod, data: data, hideNotification: true }, res => {
                  if (_getMachineProducts) {
                    getMachineProducts();
                    _getMachineProducts = false;
                  }
                });
              } else if (RequestMethod === 'PUT') {
                if (MachineInventoryItemId) {
                  fetchMssqlApi(`machine-product/${MachineProductId}`, { method: RequestMethod, data: data, hideNotification: true }, res => {
                    if (_getMachineProducts) {
                      getMachineProducts();
                      _getMachineProducts = false;
                    }
                  });
                }
                else {
                  fetchMssqlApi(`machine-product/${MachineProductId}`, { method: RequestMethod, data: data, hideNotification: true }, res => {
                    if (_getMachineProducts) {
                      getMachineProducts();
                      _getMachineProducts = false;
                    }
                  });
                }
              } else if (RequestMethod === 'DELETE') {
                if (MachineInventoryItemId) {

                  fetchMssqlApi(`machine-product/${MachineProductId}`, { method: RequestMethod, hideNotification: true }, res => {
                    if (_getMachineProducts) {
                      getMachineProducts();
                      _getMachineProducts = false;
                    }
                  })
                }
                else {
                  fetchMssqlApi(`machine-product/${MachineProductId}`, { method: RequestMethod, hideNotification: true }, res => {
                    if (_getMachineProducts) {
                      getMachineProducts();
                      _getMachineProducts = false;
                    }
                  })
                }
              }
            } else {
              NotificationManager.error(TRL_Pack.errors.correctData);
            }
          }
        }
    );
    setTimeout(() => {
      NotificationManager.success("Machines products updated successfully")
    }, modifiedMachineProducts.length * 100);
  }
  const cancelSubmit = () => {
    setMachineProducts(initialMachineProducts);
  }

  const addTableRow = () => {
    const newItem = {
      TableRowId: ++tableRowId,
      MachineFeederNo: '',
      Name: '',
      PriceBrutto: '',
      Quantity: '',
      DiscountedPrice: '',
      MaxItemCount: '20',
      TrxProductNo: '',
      notDisabled: true,
      RequestMethod: 'POST'
    }
    setMachineProducts(prev => [newItem, ...prev]);
  }

  const removeTableRow = tableRowId => {
    const newMachineProducts = [...machineProducts];

    const filteredMachineproducts = newMachineProducts.filter(newMachineProduct => newMachineProduct.TableRowId !== tableRowId);

    setMachineProducts(filteredMachineproducts);
  }

  const equalMachineProduct = (initialMachineProduct, machineProduct) => {
    if (initialMachineProduct && machineProduct)
      if (initialMachineProduct.MachineFeederNo === machineProduct.MachineFeederNo &&
          initialMachineProduct.Name === machineProduct.Name &&
          getMachineProductEan(initialMachineProduct) === getMachineProductEan(machineProduct) &&
          initialMachineProduct.MaxItemCount === machineProduct.MaxItemCount &&
          initialMachineProduct.TrxProductNo === machineProduct.TrxProductNo &&
          machineProduct.PriceBrutto === initialMachineProduct.PriceBrutto && machineProduct.Quantity === initialMachineProduct.Quantity && machineProduct.DiscountedPrice === initialMachineProduct.DiscountedPrice)
        return true;

    return false;
  }

const getProductId = (name, machineProduct) => {
  const selectedEan = getMachineProductEan(machineProduct);
  if (selectedEan) return selectedEan;

  const foundProduct = findProductByLookupValue(name);
  return foundProduct ? foundProduct.EAN : null;
};

  const getCurrentMachineId = () => Number(props.machineId)

  const getCurrentSerialNo = () => props.serialNo || props.machineSerialNo || props.machineData?.SerialNo || props.machine?.SerialNo || ''

  const getImportErrorMessage = error => {
    const data = error?.response?.data || error?.data || error || {}
    const errors = data?.errors || error?.errors

    if (Array.isArray(errors) && errors.length) {
      const visibleErrors = errors.slice(0, 6).map(err => {
        const row = err.RowNumber ? `Wiersz ${err.RowNumber}` : 'Plik'
        const field = err.FieldName ? `, ${err.FieldName}` : ''
        const message = err.Message || err.message || 'Błąd walidacji'

        return `${row}${field}: ${message}`
      })

      if (errors.length > visibleErrors.length) {
        visibleErrors.push(`I jeszcze ${errors.length - visibleErrors.length} błędów`)
      }

      return visibleErrors.join('\n')
    }

    return data?.message || error?.message || 'Nie udało się zaimportować pliku'
  }

  const saveExportFile = (response, fileName) => {
    const blob = response instanceof Blob
      ? response
      : response?.data instanceof Blob
        ? response.data
        : new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })

    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')

    link.href = url
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    link.remove()

    window.URL.revokeObjectURL(url)
  }

  const handleMachineProductsExport = () => {
    const currentMachineId = getCurrentMachineId()

    if (!currentMachineId) {
      NotificationManager.error('Najpierw zapisz automat')
      return
    }

    setIsMachineProductsExporting(true)

    fetchMssqlApi(
      'machine-products/export',
      {
        method: 'GET',
        hideNotification: true,
        responseType: 'blob',
        params: {
          machineId: currentMachineId,
          serialNo: getCurrentSerialNo()
        }
      },
      res => {
        const serialNo = getCurrentSerialNo() || currentMachineId

        saveExportFile(res, `Automat_${serialNo}.xlsx`)
        setIsMachineProductsExporting(false)
      },
      err => {
        NotificationManager.error(
          getImportErrorMessage(err),
          'Export mapowania',
          10000
        )

        setIsMachineProductsExporting(false)
      }
    )
  }

  const getMachineMaintenanceKind = machine => {
    if (Number(machine?.IsCoffee) === 1) return 'COFFEE'
    if (Number(machine?.IsSnack) === 1) return 'SNACK'

    return null
  }

  const getFallbackCurrentMachine = () => ({
    MachineId: getCurrentMachineId(),
    MachineName:
      props.machineName ||
      props.machineData?.MachineName ||
      props.machine?.MachineName ||
      'Automat',
    SerialNo: getCurrentSerialNo(),
    IsSnack: props.IsSnack ?? props.machineData?.IsSnack ?? props.machine?.IsSnack,
    IsCoffee: props.IsCoffee ?? props.machineData?.IsCoffee ?? props.machine?.IsCoffee,
  })

  const normalizeMachinesResponse = response => {
    if (Array.isArray(response?.rows)) return response.rows
    if (Array.isArray(response)) return response

    return []
  }

  const loadExtendedImportMachines = () => {
    const currentMachineId = getCurrentMachineId()

    if (!currentMachineId) {
      NotificationManager.error('Najpierw zapisz automat')
      return
    }

    setSelectedImportMachines([])
    setImportMachines([])
    setCurrentImportMachine(getFallbackCurrentMachine())
    setShowImportExtendedModal(true)
    setIsImportMachinesLoading(true)

    fetchMssqlApi(
      'machines',
      {
        method: 'POST',
        hideNotification: true,
        data: {
          machineIds: '[]',
          machineTypeId: null,
          isActive: null,
          maintenanceTypeId: null,
          locationId: null,
          cashRegisterId: null,
          sortBy: 'MachineName|ASC',
        },
      },
      response => {
        const machines = normalizeMachinesResponse(response)
        const sourceMachine = machines.find(
          machine => Number(machine.MachineId) === currentMachineId
        )
        const resolvedCurrentMachine = sourceMachine || getFallbackCurrentMachine()
        const sourceKind = getMachineMaintenanceKind(resolvedCurrentMachine)

        if (!sourceKind) {
          NotificationManager.error(
            'Nie udało się określić, czy automat jest typu SNACK czy KAWA',
            'Import'
          )
          setShowImportExtendedModal(false)
          setIsImportMachinesLoading(false)
          return
        }

        const eligibleMachines = machines.filter(machine => {
          const isCurrentMachine = Number(machine.MachineId) === currentMachineId
          const isActive = Number(machine.IsActive) === 1
          const machineKind = getMachineMaintenanceKind(machine)

          return !isCurrentMachine && isActive && machineKind === sourceKind
        })

        setCurrentImportMachine(resolvedCurrentMachine)
        setImportMachines(eligibleMachines)
        setIsImportMachinesLoading(false)
      },
      err => {
        NotificationManager.error(
          getImportErrorMessage(err),
          'Import',
          10000
        )
        setShowImportExtendedModal(false)
        setIsImportMachinesLoading(false)
      }
    )
  }

  const handleMachineProductsImportClick = () => {
    if (!isMachineProductsImporting) {
      loadExtendedImportMachines()
    }
  }

  const addImportMachine = machine => {
    setSelectedImportMachines(currentMachines => {
      const alreadySelected = currentMachines.some(
        item => Number(item.MachineId) === Number(machine.MachineId)
      )

      return alreadySelected ? currentMachines : [...currentMachines, machine]
    })
  }

  const removeImportMachine = machineId => {
    setSelectedImportMachines(currentMachines =>
      currentMachines.filter(machine => Number(machine.MachineId) !== Number(machineId))
    )
  }

  const openImportFilePicker = machines => {
    const uniqueMachines = machines.filter(
      (machine, index, items) =>
        machine?.MachineId &&
        items.findIndex(item => Number(item.MachineId) === Number(machine.MachineId)) === index
    )

    if (uniqueMachines.length === 0) {
      NotificationManager.error('Wybierz co najmniej jeden automat', 'Import')
      return
    }

    importTargetMachinesRef.current = uniqueMachines

    if (machineProductsInputRef.current) {
      machineProductsInputRef.current.click()
    }
  }

  const closeImportExtendedModal = () => {
    if (isMachineProductsImporting) return

    setShowImportExtendedModal(false)
    setSelectedImportMachines([])
    importTargetMachinesRef.current = []
  }

  const closeImportWarningModal = () => {
    if (isMachineProductsImporting) return

    setShowImportWarningModal(false)
    setPendingImportFile(null)
    setPendingImportMachines([])
    importTargetMachinesRef.current = []
  }

  const handleMachineProductsImportChange = evt => {
    const input = evt.target
    const file = input.files && input.files[0]
    const targetMachines = importTargetMachinesRef.current

    if (input) {
      input.value = ''
    }

    if (!file || isMachineProductsImporting) return

    const ext = file.name.split('.').pop()?.toLowerCase()

    if (ext !== 'xlsx') {
      NotificationManager.error('Wybierz plik .xlsx', 'Import')
      return
    }

    if (!Array.isArray(targetMachines) || targetMachines.length === 0) {
      NotificationManager.error('Wybierz co najmniej jeden automat', 'Import')
      return
    }

    setPendingImportFile(file)
    setPendingImportMachines(targetMachines)
    setShowImportExtendedModal(false)
    setShowImportWarningModal(true)
  }

  const confirmExtendedMachineProductsImport = () => {
    const currentMachineId = getCurrentMachineId()
    const targetMachineIds = pendingImportMachines
      .map(machine => Number(machine.MachineId))
      .filter(Number.isFinite)

    if (!pendingImportFile || !currentMachineId || targetMachineIds.length === 0) {
      NotificationManager.error('Brak danych wymaganych do importu', 'Import')
      return
    }

    const formData = new FormData()
    formData.append('file', pendingImportFile)
    formData.append('sourceMachineId', currentMachineId)
    formData.append('targetMachineIds', JSON.stringify(targetMachineIds))

    setIsMachineProductsImporting(true)

    fetchMssqlApi(
      'machine-products/import-extended',
      { method: 'POST', data: formData, hideNotification: true },
      () => {
        NotificationManager.success(
          'Import został zakończony pomyślnie',
          'Import'
        )

        getMachineProducts()
        setIsMachineProductsImporting(false)
        setShowImportWarningModal(false)
        setPendingImportFile(null)
        setPendingImportMachines([])
        setSelectedImportMachines([])
        importTargetMachinesRef.current = []
      },
      err => {
        NotificationManager.error(
          getImportErrorMessage(err),
          'Import',
          10000
        )

        setIsMachineProductsImporting(false)
      }
    )
  }

  const handleResetLastSales = () => {
    const confirmReset = window.confirm('Potwierdź reset sprzedaży');
    if (confirmReset)
      fetchMssqlApi(`machine-product-sales/${props.machineId}`, { method: 'PUT' }, () => {
        getMachineProducts();
      });
  }

  const saveVisit = () => {
    fetchMssqlApi(`visit`, {
      method: 'POST', data: {
        MachineId: props.machineId,
        IsCoinInventory: true
      }
    }, () => {
      getMachineProducts();
    });
  }

  const formatPLN = (v) => {
    const n = Number(String(v ?? "").replace(",", "."));
    if (!Number.isFinite(n) || n === 0) return "";
    return `${n.toFixed(2).replace(".", ",")} zł`;
  };

  const getDepositLabel = (p) => {
    const depName = String(p?.DepositName || "").trim();
    if (depName) return depName;

    const price = p?.DepositPrice ?? p?.Deposit;
    const pln = formatPLN(price);
    return pln || "";
  };

  const productOptionValue = (p) => {
    const name = p?.Name || "";
    const dep = getDepositLabel(p);
    return dep ? `${name} (${dep})` : name;
  };

  const productEanOptionValue = (p) => {
    const ean = String(p?.EAN ?? "");
    const name = p?.Name || "";
    return name ? `${ean} (${name})` : ean;
  };

  const findProductByLookupValue = (raw) => {
    const value = String(raw ?? "");

    return (product || []).find((p) =>
      p.Name === value ||
      String(p.EAN) === value ||
      productOptionValue(p) === value ||
      productEanOptionValue(p) === value
    );
  };

  const getMachineProductEan = (machineProduct) => {
    const currentEan =
      machineProduct?.SelectedEAN ??
      machineProduct?.EAN ??
      machineProduct?.Ean ??
      machineProduct?.ProductEAN ??
      machineProduct?.ProductEan;

    if (currentEan !== null && currentEan !== undefined && currentEan !== "") {
      return String(currentEan);
    }

    return String(findProductByLookupValue(machineProduct?.Name)?.EAN ?? "");
  };

  const getProductLookupValue = (machineProduct) => {
    const currentEan = getMachineProductEan(machineProduct);
    const selectedProduct = currentEan
      ? (product || []).find((p) => String(p.EAN) === currentEan)
      : findProductByLookupValue(machineProduct?.Name);

    if (!selectedProduct) return machineProduct?.Name || "";

    return productLookupType === 'ean'
      ? productEanOptionValue(selectedProduct)
      : selectedProduct.Name;
  };

  const productDatalistOptions = (product || []).map((p) =>
    productLookupType === 'ean'
      ? productEanOptionValue(p)
      : productOptionValue(p)
  );

  const productValidationList = productLookupType === 'ean'
    ? productDatalistOptions
    : (product || []).map((p) => p.Name);

  return (
      <div className="card">
        <input
          ref={machineProductsInputRef}
          type="file"
          accept=".xlsx"
          disabled={isMachineProductsImporting}
          onChange={handleMachineProductsImportChange}
          style={{ display: 'none' }}
        />


        <ImportExtendedModal
          show={showImportExtendedModal}
          currentMachine={currentImportMachine}
          machines={importMachines}
          selectedMachines={selectedImportMachines}
          isLoading={isImportMachinesLoading}
          isImporting={isMachineProductsImporting}
          onAddMachine={addImportMachine}
          onRemoveMachine={removeImportMachine}
          onImportCurrent={() => openImportFilePicker([currentImportMachine])}
          onImportMany={() => openImportFilePicker(selectedImportMachines)}
          onClose={closeImportExtendedModal}
        />

        <ImportWarningModal
          show={showImportWarningModal}
          machines={pendingImportMachines}
          isImporting={isMachineProductsImporting}
          onClose={closeImportWarningModal}
          onConfirm={confirmExtendedMachineProductsImport}
        />

        <h5 className="card-header">
          {TRL_Pack.fullMachine.listOfProduct}
          <span className="ml-2 badge badge-info">{machineProducts.length}</span>
          <button className="float-right btn btn-sm btn-link text-decoration-none" onClick={addTableRow}>
            <i className="fas fa-plus mr-2" />
            {TRL_Pack.fullMachine.new}
          </button>
          <button className="float-right btn btn-sm btn-link text-decoration-none" onClick={() => saveVisit()}>
            <i className="fas fa-save mr-1" />
            {TRL_Pack.fullMachine.saveVisit}
          </button>
          <button
              className="float-right btn btn-sm btn-link text-decoration-none mr-2"
              disabled={isMachineProductsImporting || !getCurrentMachineId()}
              onClick={handleMachineProductsImportClick}
          >
            <i className="fas fa-file-import mr-2" />
            Import
          </button>
          {initialMachineProducts.length > 0 && (
              <Fragment>
                <button
                    className="float-right btn btn-sm btn-link text-decoration-none mr-2"
                    disabled={isMachineProductsExporting || !getCurrentMachineId()}
                    onClick={handleMachineProductsExport}
                >
                  <i className="fas fa-file-export mr-2" />
                  Export
                </button>
                <button
                    className="float-right btn btn-sm btn-link text-decoration-none mr-2"
                    onClick={handleResetLastSales}>
                  <i className="fas fa-eraser mr-2" />
                  {TRL_Pack.fullMachine.salesReset}
                </button>
              </Fragment>
          )}
          <button className="float-right btn btn-sm btn-link text-decoration-none" onClick={props.enableConfigurationModal}>
            <i className="fas fa-plus mr-2" />
            Kopiuj konfigurację
          </button>
        </h5>
        <datalist id="Name">
          {productDatalistOptions.map((value, idx) => (
            <option key={idx} value={value} />
          ))}
        </datalist>
        <div className="overflow-auto custom-scroll" style={{ maxHeight: 550 }}>
          <Prompt
              when={isTableModified}
              message="Wykryto niezapisane zmiany, czy na pewno chcesz opuścić stronę?"
          />
          <table className="table table-striped">
            <thead>
            <tr>
              <th>{TRL_Pack.machineRecipies.number}</th>
              <th colSpan={2} style={{width: '50%'}} className="machine-products-col">
                <div className="machine-products-buttons">
                  <button
                      type="button"
                      className={`btn btn-link text-decoration-none font-size-force-11 machine-products-btn ${productLookupType === 'name' ? 'machine-products-btn-active' : 'text-dark'}`}
                      onClick={() => setProductLookupType('name')}
                  >
                    {TRL_Pack.machineRecipies.recipies}
                  </button>
                  <button
                      type="button"
                      className={`btn btn-link text-decoration-none font-size-force-11 machine-products-btn ${productLookupType === 'ean' ? 'machine-products-btn-active' : 'text-dark'}`}
                      onClick={() => setProductLookupType('ean')}
                  >
                    EAN
                  </button>
                </div>
              </th>
              <th>{TRL_Pack.machineRecipies.price}</th>
              {/* <th>{TRL_Pack.machineRecipies.discountedPrice}</th> */}
              <th>{TRL_Pack.machineRecipies.quantity}</th>
              <th>{TRL_Pack.machineRecipies.capacity}</th>
              <th>Kod MDB</th>
              {/* <th className="text-center">{TRL_Pack.machineRecipies.lastSales}</th> */}
              <th style={{ width: '1%' }} />
            </tr>
            </thead>
            <tbody>
            {machineProducts.map((machineProduct, id) => (
                <tr key={id}>
                  <td>
                    <TextInput
                        disabled={machineProducts[id].notDisabled ? null : true}
                        style={{ minWidth: "40px", maxWidth: "80px", minWidth: 50 }}
                        name="MachineFeederNo"
                        value={machineProduct.MachineFeederNo}
                        handleChange={(e => handleChange(machineProduct.MachineProductId, e, machineProduct.TableRowId))}
                        required
                    />
                  </td>
                  <td colSpan={2}>
                    <DatalistInput
                        name="Name"
                        style={{ minWidth: 150}}
                        value={getProductLookupValue(machineProduct)}
                        handleChange={(e => handleChange(machineProduct.MachineProductId, e, machineProduct.TableRowId))}
                        list={productValidationList}
                    />
                  </td>
                  <td>
                    <TextInput
                        style={{ maxWidth: 100, minWidth: 70 }}
                        name="PriceBrutto"
                        value={machineProduct.PriceBrutto}
                        handleChange={(e => handleChange(machineProduct.MachineProductId, e, machineProduct.TableRowId))}
                        type="number"
                        min={0}
                        step={0.01}
                        max={1000}
                        required
                    />
                  </td>
                  {/* <td>
                    <TextInput
                        style={{ maxWidth: 100, minWidth: 70 }}
                        name="DiscountedPrice"
                        value={machineProduct.DiscountedPrice || ""}
                        handleChange={(e => handleChange(machineProduct.MachineProductId, e, machineProduct.TableRowId))}
                        type="number"
                        min={0}
                        step={0.1}
                        max={1000}
                    />
                  </td> */}
                  <td>
                    <TextInput
                        className={ machineProduct.Quantity === 0 ? 'invalid-input' : '' }
                        style={{ maxWidth: 100, minWidth: 70 }}
                        name="Quantity"
                        value={machineProduct.Quantity === 0 ? "0" : machineProduct.Quantity}
                        handleChange={(e => handleChange(machineProduct.MachineProductId, e, machineProduct.TableRowId))}
                        type="number"
                        min={0}
                        max={machineProduct.MaxItemCount}
                    />
                  </td>

                  <td>
                    <TextInput
                        style={{ maxWidth: 100, minWidth: 70 }}
                        name="MaxItemCount"
                        value={machineProduct.MaxItemCount}
                        disabled={localStorage.getItem('clientId') === 'hap' &&  true}
                        handleChange={(e => handleChange(machineProduct.MachineProductId, e, machineProduct.TableRowId))}
                        type="number"
                        min={1}
                        required
                    />
                  </td>
                  <td>
                    <TextInput
                        style={{ maxWidth: 100, minWidth: 70 }}
                        name="TrxProductNo"
                        value={machineProduct.TrxProductNo || ""}
                        handleChange={(e => handleChange(machineProduct.MachineProductId, e, machineProduct.TableRowId))}
                        type="number"
                        min={0}
                    />
                  </td>
                  {/* <td className="text-center">{machineProduct.LastSalesTotal || 0}</td> */}
                  <td className="text-center">
                    <button
                        className="btn btn-link btn-sm"
                        onClick={machineProduct.RequestMethod === 'POST' ? () => removeTableRow(machineProduct.TableRowId) : () => toggleDeleteMachineProduct(machineProduct.MachineProductId)}
                    >
                      {machineProduct.RequestMethod === 'DELETE' ? (
                          <i className="fas fa-trash-restore" />
                      ) : (
                          machineProduct.RequestMethod === 'POST' ? (
                              <i className="fas fa-times" />
                          ) : (
                              <i className="fas fa-trash" />
                          )

                      )}
                    </button>
                  </td>
                </tr>
            ))}
            </tbody>
          </table>
        </div>
        <div className="card-footer text-center">
          <button className="btn btn-secondary btn-sm mr-3" onClick={cancelSubmit} disabled={!isTableModified}>{TRL_Pack.buttons.cancel}</button>
          <button className="btn btn-success btn-sm" onClick={(e) => handleSubmit(e)} disabled={!isTableModified}>{TRL_Pack.buttons.save}</button>
        </div>
      </div>
  )
}

export default MachineProducts;